import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

export default {
  getPatientList: (filters = {}) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/medical-records`, {
      urlParams: { access_token: accessToken },
      data: filters,
    });
  },

  getPatient: (id) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/medical-records/${id}`, {
      urlParams: { access_token: accessToken },
    });
  },

  updatePatient: (medicalRecord, id) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('PATCH', `${config.bocaAPIUrl}/medical-records/${id}`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(medicalRecord),
    });
  },

  createPatient: (patient) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/medical-records`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(patient),
    });
  },

  createWound: (wound) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    const medicalRecordId = wound.medicalRecordId;
    return ajax('POST', `${config.bocaAPIUrl}/medical-records/${medicalRecordId}/wounds`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(wound),
    });
  },

  createAssessment: (assessment) => {
    const woundId = assessment.woundId;
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/wounds/${woundId}/assessments`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(assessment),
    });
  },

  updateAssessment: (statistics, assessId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('PATCH', `${config.bocaAPIUrl}/assessments/${assessId}`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(statistics),
    });
  },

  updateRecommendation: (recommendation, assessId, recId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    if (recId === undefined) {
      return ajax('POST', `${config.bocaAPIUrl}/assessments/${assessId}/recommendations`, {
        urlParams: { access_token: accessToken },
        data: JSON.stringify(recommendation),
      });
    }
    return ajax('PUT', `${config.bocaAPIUrl}/assessments/${assessId}/recommendations/${recId}`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(recommendation),
    });
  },

  uploadAssessmentPhoto: (formData, assessmentId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/assessments/${assessmentId}/photos`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },

  uploadPatientPhoto: (formData, medicalRecordId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/medical-records/${medicalRecordId}/photos`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },

  referPatient: (medicalRecordId, email) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/medical-records/${medicalRecordId}/refer`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify({ email }),
    });
  },

  getExportPDF: (pdfId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    // TODO: The downloading page will crash if server responds an error.
    //  Currently, we just open a new page to prevent the main page from crashing.
    //  Refactor this endpoint if there is a better solution.
    window.open(`${config.bocaAPIUrl}/wounds/${pdfId}/export?access_token=${accessToken}`, '_blank');
  },
};



// WEBPACK FOOTER //
// ./src/api/PatientAPIConnectors.js